import { render, staticRenderFns } from "./licenseInformation.vue?vue&type=template&id=878fb43a&"
import script from "./licenseInformation.vue?vue&type=script&lang=js&"
export * from "./licenseInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports